import { TableCell, TableRow, useTheme } from "@material-ui/core";

import React from "react";
import { useTranslate } from "react-admin";

function backgroundColor(theme, month, start_month, duration) {
  if (month <= start_month + duration - 1 && month >= start_month) {
    return theme.palette.primary.main;
  } else {
    return "white";
  }
}

const WpRows = ({ wp, index, months }) => {
  const theme = useTheme();
  const translate = useTranslate();
  return (
    <TableRow key={index}>
      <TableCell>
        {wp.index && translate("resources.crono.fields.wp", wp)}
      </TableCell>
      {months?.map((month, index) => (
        <TableCell
          style={{
            backgroundColor: backgroundColor(
              theme,
              month,
              wp.start_month,
              wp.duration
            ),
          }}
          key={index}
        ></TableCell>
      ))}
    </TableRow>
  );
};
export default WpRows;
